module.exports = __webpack_public_path__ + "static/img/banner-2.24f37fc5.jpg";